import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AppointmentsPage } from "@/features/appointments/appointments-page";
import { baseListSearch, optionalEnum, optionalString } from "@/lib/list-state";

export const Route = createFileRoute("/_authenticated/appointments/")({
  validateSearch: z.object({
    ...baseListSearch,
    organizationId: optionalString,
    storeId: optionalString,
    status: optionalEnum(["PROPOSED", "SCHEDULED", "CONFIRMED", "SHOWED", "NO_SHOW", "CANCELLED"] as const),
    date: optionalEnum(["today", "upcoming", "past"] as const),
  }),
  head: () => ({ meta: [{ title: "Appointments · Rogue Admin" }] }),
  component: AppointmentsPage,
});
